export default "__VITE_ASSET__d972b95e__"